import {Badge, Title as MantineTitle, Text} from '@mantine/core';
import type {FC} from 'react';
import {cn} from '../../../../../lib/classname';
import {FollowCompanyButton} from './FollowCompanyButton';
import type {ListType} from './list-type';

const DEFAULT_DESCRIPTION =
  '就活に役立つノウハウを幅広く提供。就活、選考対策のブラッシュアップにつなげよう！';

type Props = {
  className?: string;
  title: string;
  description?: string;
  listType?: ListType;
};
export const Title: FC<Props> = ({
  className,
  title,
  description = DEFAULT_DESCRIPTION,
  listType,
}) => {
  return (
    <>
      <TitleForMobile
        className={cn('pc:hidden', className)}
        title={title}
        description={description}
        listType={listType}
      />
      <TitleForPC
        className={cn('hidden pc:flex', className)}
        title={title}
        description={description}
        listType={listType}
      />
    </>
  );
};

const TitleForMobile: FC<Props> = ({
  className,
  title,
  description,
  listType,
}) => {
  return (
    <div className={cn('bg-white p-16 space-y-8', className)}>
      <div className="flex flex-col items-start">
        <MantineTitle order={1} className="text-lg">
          <span className="font-[inherit]">{title}</span>
          {listType === 'company' && (
            <Badge
              color="blue"
              variant="light"
              className="ml-8 relative top-[-2px]"
            >
              人気順
            </Badge>
          )}
        </MantineTitle>
      </div>
      <Text className="text-base text-black-1">{description}</Text>
      <div className="w-full">
        {listType === 'company' && (
          <div className="flex justify-end">
            <FollowCompanyButton />
          </div>
        )}
      </div>
    </div>
  );
};

const TitleForPC: FC<Props> = ({className, title, description, listType}) => {
  return (
    <div
      className={cn(
        'bg-white p-16 rounded-16 shadow flex items-center justify-between gap-24',
        className,
      )}
    >
      <div className="w-full">
        <MantineTitle order={1} className="text-lg ">
          <span className="font-[inherit]">{title}</span>
          {listType === 'company' && (
            <Badge
              color="blue"
              variant="light"
              className="ml-8 relative top-[-3px]"
            >
              人気順
            </Badge>
          )}
        </MantineTitle>
        <Text className="text-base text-black-1">{description}</Text>
      </div>
      <div>
        {listType === 'company' && (
          <div className="flex items-center gap-x-8">
            <FollowCompanyButton />
          </div>
        )}
      </div>
    </div>
  );
};
